import { Component, Input } from '@angular/core';

@Component({
  selector: 'lgv-bool-table-item',
  template: ' @if (value) {<mat-icon class="material-icons-outlined">done</mat-icon>} ',
  styles: [':host{display:flex}'],
  standalone: false,
})
export class BoolTableItemComponent {
  @Input() value: boolean;
}
